/**
 * Backend көп жерде уақытты naive UTC етіп береді («2026-10-01T07:48:00», «Z»-сыз).
 * `new Date()` ондайды жергілікті уақыт деп оқиды → Алматыда 5 сағатқа қателеседі.
 * Белдеуі жоқ ISO-ны UTC деп оқимыз.
 */
export const parseServerDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const s = String(value);
  const naive = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(s);
  return new Date(naive ? `${s}Z` : s);
};
